export default "__VITE_ASSET__BLbGs5aK__"